/**
 * @generated SignedSource<<3803c069fc5f359eb7c157fbe6f91e2d>>
 * @relayHash 5e1a8355bfc268a50ad2ce1cd9381916
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0b88860d99320aa5d048762b2b6a0ab86c6931ae19cd8a2c07e53caf2111f313

import type { ConcreteRequest, Query } from 'relay-runtime';
export type uiMultiGroupPickerFieldSearchRefetchQuery$variables = {
  after?: string | null | undefined;
  first: number;
  id: string;
  searchBy: string;
};
export type uiMultiGroupPickerFieldSearchRefetchQuery$data = {
  readonly node: {
    readonly groups?: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly groupId: string;
          readonly id: string;
          readonly name: string;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type uiMultiGroupPickerFieldSearchRefetchQuery = {
  response: uiMultiGroupPickerFieldSearchRefetchQuery$data;
  variables: uiMultiGroupPickerFieldSearchRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchBy"
},
v4 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v5 = {
  "kind": "Variable",
  "name": "searchBy",
  "variableName": "searchBy"
},
v6 = {
  "kind": "ScalarField",
  "name": "id"
},
v7 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v8 = [
  {
    "concreteType": "JiraGroupEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "concreteType": "JiraGroup",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          {
            "kind": "ScalarField",
            "name": "name"
          },
          {
            "kind": "ScalarField",
            "name": "groupId"
          },
          (v7/*: any*/)
        ]
      },
      {
        "kind": "ScalarField",
        "name": "cursor"
      }
    ]
  },
  {
    "concreteType": "PageInfo",
    "kind": "LinkedField",
    "name": "pageInfo",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "endCursor"
      },
      {
        "kind": "ScalarField",
        "name": "hasNextPage"
      }
    ]
  }
],
v9 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  (v5/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "uiMultiGroupPickerFieldSearchRefetchQuery",
    "selections": [
      {
        "args": (v4/*: any*/),
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": "groups",
                "args": [
                  (v5/*: any*/)
                ],
                "concreteType": "JiraGroupConnection",
                "kind": "LinkedField",
                "name": "__multiGroupPicker_issueFieldMultiGroupPicker_groups_connection",
                "plural": false,
                "selections": (v8/*: any*/)
              }
            ],
            "type": "JiraMultipleGroupPickerField"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "uiMultiGroupPickerFieldSearchRefetchQuery",
    "selections": [
      {
        "args": (v4/*: any*/),
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v7/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": (v9/*: any*/),
                "concreteType": "JiraGroupConnection",
                "kind": "LinkedField",
                "name": "groups",
                "plural": false,
                "selections": (v8/*: any*/)
              },
              {
                "args": (v9/*: any*/),
                "filters": [
                  "searchBy"
                ],
                "handle": "connection",
                "key": "multiGroupPicker_issueFieldMultiGroupPicker_groups",
                "kind": "LinkedHandle",
                "name": "groups"
              }
            ],
            "type": "JiraMultipleGroupPickerField"
          },
          (v6/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "id": "0b88860d99320aa5d048762b2b6a0ab86c6931ae19cd8a2c07e53caf2111f313",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": [
            "node",
            "groups"
          ]
        }
      ]
    },
    "name": "uiMultiGroupPickerFieldSearchRefetchQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "aeaacce2c1fd225c980849027d0bba0e";

export default node;
